import { Auth0Client } from '@auth0/auth0-spa-js'

import { getSmartSocietyAuthConfig } from './smartSocietyAuthConfig'

let clientPromise: Promise<Auth0Client> | null = null

export function getSmartSocietyAuthClient(): Promise<Auth0Client> {
  if (!clientPromise) {
    const config = getSmartSocietyAuthConfig()

    clientPromise = Promise.resolve(
      new Auth0Client({
        domain: config.domain,
        clientId: config.clientId,
        cacheLocation: 'memory',
        authorizationParams: {
          redirect_uri: config.redirectUri,
          audience: config.audience
        }
      })
    )
  }

  return clientPromise
}
